// web has no concept of "installing" and "uninstalling"
const useAppInstallation = () => ({ isFirstLaunchSetupDone: true });

type UseAppInstallation = ReturnType<typeof useAppInstallation>;

export type { UseAppInstallation };
export default useAppInstallation;
